import './trips.css';
import DriversSummary from "../../components/driverComponent/driversSummary/driversSummary";

import {tripSummary} from "../../data/driversData";
import {useContext, useEffect, useState} from "react";
import TripsCard from "../../components/tripsComponent/tripsCards/tripsCards";
import AllTrips from "../../components/tripsComponent/allTrips/allTrips";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import {format} from "date-fns";
import TripService from "../../services/trip.service";
import tripService from "../../services/trip.service";
import Loaders from "../../shared/loaders/loaders";
import AppContext from "../../contexts/appContext/app.context";
import {useSelector} from "react-redux";

const Trips = () => {
    const appCtx = useContext(AppContext);
    const [summary, setSummary] = useState(tripSummary);
    const [startDate, setStartDate] = useState(appCtx.startDate);
    const [endDate, setEndDate] = useState(appCtx.endDate);
    const [trips, setTrips] = useState([]);
    // const [tripsCounts, setTripsCounts] = useState({});
    const [tripsPages, setTripsPages] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [distanceLoader, setDistanceLoader] = useState(true);
    const [summaryLoader, setSummaryLoader] = useState(true);
    const [tripsLoader, setTripsLoader] = useState(true);
    const [tripsError, setTripsError] = useState(null);
    const tripFilters = useSelector(state => state.tripsFilter)

    const startDateFormatted = format(new Date(startDate), 'yyyy-MM-dd');
    const endDateFormatted = format(new Date(endDate), 'yyyy-MM-dd');

    const handleDateChange = (date) => {
        if (date[1]) {
            setStartDate(date[0]);
            setEndDate(date[1]);
        }
    }

    // ...... get trips .......
    const getTrips = async (pageNumber = 1,
                            pSize = 10,
                            filters = tripFilters) => {
        setTripsLoader(true);
        setTripsError(null);
        const tripsData = await TripService.getTrips(startDateFormatted, endDateFormatted, pageNumber, pSize, filters);
        if (!tripsData?.message) {
            setTrips(tripsData?.trips);
            setTripsPages(tripsData?.meta);
        } else {
            setTrips([]);
            setTripsError(tripsData?.message);
        }
        setTripsLoader(false);
    }

    // ..... get trip counts .......
    const getTripCounts = async () => {
        setDistanceLoader(true);
        const tripsCount = await TripService.getTripCounts(startDateFormatted, endDateFormatted);
        if (!tripsCount?.message) {
            setSummary((prevState) => {
                return {
                    ...prevState,
                    counts: tripsCount
                }
            })
        } else {
            setSummary((prevState) => {
                return {
                    ...prevState,
                    counts: []
                }
            })
        }
        setDistanceLoader(false);
    }

    // ...... get alerts ........
    const getAlerts = async () => {
        setSummaryLoader(true);
        const alerts = await tripService.getTripAlerts(startDateFormatted, endDateFormatted);
        console.log(alerts)
        if (!alerts?.message) {
            setSummary((prevState) => {
                return {
                    ...prevState,
                    alerts: alerts
                }
            })
        } else {
            setSummary((prevState) => {
                return {
                    ...prevState,
                    alerts: []
                }
            })
        }
        setSummaryLoader(false);
    }

    const onPageChange = async (page) => {
        setShowLoader(true);
        await getTrips(page);
        setShowLoader(false);
    }


    useEffect(() => {
        getTrips(1);
        getTripCounts();
        getAlerts();

    }, [endDate, tripFilters]);


    return (
        <div className={'page-fade-in'}>
            <div className={'content-section'}>
                <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                    <DateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        selectRange={true}
                        onDateChange={handleDateChange}
                        classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>

                {/*..... card dashboard .....*/}
                <div className="margin-b-10 trips-card-box">
                    <TripsCard totalTrips={summary?.counts?.currentPeriod?.count}/>
                </div>

                {/*..... overall summary .....*/}
                {/*<div className="margin-b-50"><OverallSummary/></div>*/}
            </div>
            <div className={'margin-b-30'}>
                <div className={'content-section'}>
                    {/*..... drivers overall summary .....*/}
                    <div className=" border-bottom padding-b-20">
                        <DriversSummary summary={summary}
                                        distanceLoader={distanceLoader}
                                        summaryLoader={summaryLoader}/>
                    </div>
                </div>
            </div>

            <div className="">
                <div className={'content-section'}>
                    {/*..... All trips .....*/}
                    <div className="">
                        <AllTrips trips={trips}
                                  tripsLoader={tripsLoader}
                                  onPageChange={onPageChange}
                                  pagination={tripsPages}
                                  tripError={tripsError}/>
                    </div>
                </div>
            </div>

            {showLoader &&
                <div className="loader-box blue-loader">
                    <Loaders/>
                </div>
            }
        </div>
    )
}

export default Trips;
